// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Y2YX0","agreement":"styles_agreement__Bl9kh","button":"styles_button__l0pgc","buttonSign":"styles_buttonSign__zkw4x"};